import React, { useState } from "react";
import { calculatePrice, getLatLng } from "../../Services/Services";
import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import css from "./Inputs.module.css";
import Inputs from "./Inputs";
import Banner from "../Banner/Banner";
import { useHistory } from "react-router-dom";

export default function InputsContainer(props) {
  let history = useHistory();
  const [origin, setOrigin] = useState({
    calle: "",
    calleId: 0,
    numero: "",
    lat: 0.0,
    lng: 0.0,
    calleErrorState: false,
    numeroErrorState: false,
  });
  const [destiny, setDestiny] = useState({
    calle: "",
    calleId: 0,
    numero: "",
    lat: 0.0,
    lng: 0.0,
    calleErrorState: false,
    numeroErrorState: false,
  });

  const [calculating, setCalculating] = useState(false);
  const [error, setError] = useState(false);
  const [errorTxt, setErrorTxt] = useState("");

  const handleCalleOriginChange = (e) => {
    if (e) {
      setOrigin({ ...origin, calle: e.target.value });
    }
  };
  const handleCalleIdOriginChange = (e, val) => {
    if (val) {
      setOrigin({ ...origin, calle: val.NombreCalle, calleId: val.idCalle });
    }else{
      setOrigin({ ...origin, calle: "", calleId: 0 });
    }
  };
  const handleCalleDestinyChange = (e) => {
    if (e) setDestiny({ ...destiny, calle: e.target.value });
  };
  const handleCalleIdDestinyChange = (e, val) => {
    if (val) {
      setDestiny({ ...destiny, calle: val.NombreCalle, calleId: val.idCalle });
    }
  };

  const handleNumeroOriginChange = (e) => {
    setOrigin({ ...origin, numero: e.target.value });
  };

  const handleNumeroDestinyChange = (e) => {
    setDestiny({ ...destiny, numero: e.target.value });
  };
  const fetchLatLng = async (calleId, numero) => {
    // 3316 Daniel García Acevedo
    const getedLatLng = await getLatLng(calleId, numero);
    if (getedLatLng) {
      if (getedLatLng[0].latitud !== 0 && getedLatLng[0].longitud !== 0) {
        return getedLatLng;
      } else {
        return false;
      }
    } else {
      return false;
    }
  };

  const fetchCalculatePrice = async (originLatlng, destinyLatLng) => {
    const calculatedPrice = await calculatePrice(originLatlng.latitud, originLatlng.longitud, destinyLatLng.latitud, destinyLatLng.longitud);
    if (calculatedPrice) {
      props.handleSetResult({
        originLatLng: originLatlng,
        destinyLatLng: destinyLatLng,
        origin: origin,
        destiny: destiny,
        price: calculatedPrice,
      });
      history.push({
        pathname: "/result",
      });
    } else {
      return false;
    }
  };

  const checkCalle =  (type) => {
    const calle = props.calles.filter((calle) => {
      return calle.NombreCalle.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "") === (type === "origin" ? origin.calle.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "") : type === "destiny" ? destiny.calle.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "") : null);
    });

    if (calle.length > 1) {
      return false;
    } 

    if(calle.length){
      return calle[0].idCalle
    }else{
      return false;
    }
      
  };

  const startCalculating = async () => {
    setCalculating(true);

    const validatingOk = await validateAddresses();
    if (validatingOk) {
      const calculatingOk = await fetchCalculatePrice(validatingOk.origin[0], validatingOk.destiny[0]);
      if (calculatingOk) {
      } else {
        setCalculating(false);
      }
    } else {
      setCalculating(false);
    }
  };

  const validateAddresses = async () => {
    setCalculating(true);
    let originOk = false;
    let destinyOk = false;

    setOrigin({ ...origin, calleErrorState: false, numeroErrorState: false });
    setDestiny({ ...destiny, calleErrorState: false, numeroErrorState: false });
    setError(false);
    setErrorTxt("");

    if (!origin.calle.length || !origin.numero.length) {
      setError(true);
      setErrorTxt("Debe Ingresar un Origen para continuar");

      if (!origin.numero.length) {
        setOrigin({ ...origin, numeroErrorState: true });
      }
      if (!origin.calle.length) {
        setOrigin({ ...origin, calleErrorState: true });
      }
      return false;
    }

    if (!destiny.calle.length && !destiny.numero.length && !origin.calle && !origin.numero) {
      setError(true);
      setErrorTxt("Para calcular la tarifa debe ingresar un Origen y un Destino");
      return false;
    }
    // if (destiny.calle.length && destiny.numero.length && origin.calle.length && origin.numero.length) {
    if (!destiny.calle.length || !destiny.numero.length) {
      setError(true);
      setErrorTxt("Debe Ingresar un Destino para continuar");

      if (!destiny.calle.length) {
        setDestiny({ ...destiny, calleErrorState: true });
      }
      if (!destiny.numero.length) {
        setDestiny({ ...destiny, numeroErrorState: true });
      }
      return false;
    }

    const originLatLng = await fetchLatLng(origin.calleId !== 0 ? origin.calleId : checkCalle("origin"), origin.numero);
    if (originLatLng) {
      setOrigin({ ...origin, lat: originLatLng.latitud, lng: originLatLng.longitud });
      originOk = true;
    } else {
      setError(true);
      setErrorTxt("No se pudo encontrar la Dirección de Origen Indicada");
      setOrigin({ ...origin, lat: 0.0, lng: 0.0 });
      return false;
    }

    const destinyLatLng = await fetchLatLng(destiny.calleId !== 0 ? destiny.calleId : checkCalle("destiny"), destiny.numero);
    if (destinyLatLng) {
      setDestiny({ ...destiny, lat: destinyLatLng.latitud, lng: destinyLatLng.longitud });
      destinyOk = true;
    } else {
      setError(true);
      setErrorTxt("No se pudo encontrar la direccion de Destino Indicada");
      setDestiny({ ...destiny, lat: 0.0, lng: 0.0 });
      return false;
    }

    if (originOk && destinyOk) {
      const result = {
        origin: originLatLng,
        destiny: destinyLatLng,
      };
      return result;
    }
  };

  return (
    <>
      <div className={css.InputContainer}>
        <Banner state={error ? "error" : null}>{errorTxt}</Banner>
        <Inputs
          calles={props.calles}
          handleCalleIdChange={handleCalleIdOriginChange}
          handleCalleChange={handleCalleOriginChange}
          handleNumeroChange={handleNumeroOriginChange}
          calle={origin.calle}
          numero={origin.numero}
          title="Origen"
        ></Inputs>
        <Inputs
          calles={props.calles}
          handleCalleIdChange={handleCalleIdDestinyChange}
          handleCalleChange={handleCalleDestinyChange}
          handleNumeroChange={handleNumeroDestinyChange}
          calle={destiny.calle}
          numero={destiny.numero}
          title="Destino"
        ></Inputs>{" "}
        <div className={css.ButtonsContainer}>
          {calculating ? (
            <CircularProgress />
          ) : (
            <Button variant="contained" color="primary" disableElevation fullWidth onClick={startCalculating}>
              Calcular
            </Button>
          )}
        </div>
      </div>
    </>
  );
}
